import { render, staticRenderFns } from "./pi-user-tag.vue?vue&type=template&id=7a22c52e&scoped=true&"
import script from "./pi-user-tag.vue?vue&type=script&lang=js&"
export * from "./pi-user-tag.vue?vue&type=script&lang=js&"
import style0 from "./pi-user-tag.vue?vue&type=style&index=0&id=7a22c52e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22c52e",
  null
  
)

export default component.exports